import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface LayoutBackgroundColorOpacityOptionProps {
  backgroundColorAlpha: number;
  updateOpacity(backgroundColorAlpha: number, undoable?: boolean): void;
  className?: string;
}

const LAYOUT_BACKGROUND_OPACITY_MIN = 0;
const LAYOUT_BACKGROUND_OPACITY_DISPLAY_MIN = 0;
const LAYOUT_BACKGROUND_OPACITY_MAX = 1;
const LAYOUT_BACKGROUND_OPACITY_DISPLAY_MAX = 100;

export function LayoutBackgroundColorOpacityOption({className = '', ...props}: LayoutBackgroundColorOpacityOptionProps): ReactElement<any> {
  const onChangeOpacity = (updatedValue: number): void => {
    props.updateOpacity(updatedValue, false);
  };

  const onChangeOpacityEnded = (updatedValue: number): void => {
    props.updateOpacity(updatedValue, true);
  };

  return (
    <ContextualMenuSliderOptions
      id="menu-background-opacity-option"
      className={className}
      value={props.backgroundColorAlpha}
      label={window.i18next.t('pmwjs_opacity')}
      range={{
        min: LAYOUT_BACKGROUND_OPACITY_MIN,
        max: LAYOUT_BACKGROUND_OPACITY_MAX,
      }}
      transformDisplay={{
        min: LAYOUT_BACKGROUND_OPACITY_DISPLAY_MIN,
        max: LAYOUT_BACKGROUND_OPACITY_DISPLAY_MAX,
      }}
      onChange={onChangeOpacity}
      onChangeEnded={onChangeOpacityEnded}
    />
  );
}
